// Kept separate from the API/action modules so auth can reset telemetry without
// an auth -> board API -> auth import cycle. Refresh/reload must not reset it.
export const reportedBoardViews = new Set<string>();
export let boardViewSessionGeneration = 0;

export function resetBoardViewSession(): void {
  reportedBoardViews.clear();
  boardViewSessionGeneration++;
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key?.startsWith('board-seen:')) sessionStorage.removeItem(key);
    }
  } catch { /* Storage may be disabled; the in-memory set is still reset. */ }
}
